const DEFAULT_CHATBOT_URL = "https://chatbot-conectado.gentop.tech/";

const getConfiguredChatbotUrl = () =>
  process.env.REACT_APP_CHATBOT_URL?.trim() || DEFAULT_CHATBOT_URL;

export const buildChatbotUrl = (
  sessionToken: string,
  parentOrigin = window.location.origin
) => {
  const token = sessionToken.trim();

  if (!token) {
    throw new Error("O backend não retornou uma sessão válida do ChatBot.");
  }

  const chatbotUrl = new URL(getConfiguredChatbotUrl());
  chatbotUrl.searchParams.set("userSession", token);
  chatbotUrl.searchParams.set("integration", "portal-web");
  chatbotUrl.searchParams.set("parentOrigin", parentOrigin);

  return chatbotUrl.toString();
};
